// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox--R5Ga4","checked":"checked--IOEWM","checkboxIcon":"checkboxIcon--rkGA2"};